const semanticClassNames = {
  root: 'mobile-menu',
} as const;

export default semanticClassNames;
